import JourneyService from 'src/services/journeys.service'

const useJourneyStepRemove = () => {
  const fn = (stepIds: string[], journeyArr: string[]) =>
    JourneyService.removeStepFromOrder(stepIds, journeyArr)
  return fn
}

export { useJourneyStepRemove }
